import { ApiService } from './ApiService';
import apiResponse from './ApiResponse';

export class CacheStore {
  constructor(private readonly api: ApiService = new ApiService()) {}

  public async ClearAllCache() {
    try {
      const result = await this.api.post('admin/cache/clearEntireCache', {});
      return apiResponse.Success(result);
    } catch (e) {
      return apiResponse.HandleError(e);
    }
  }
}
